module.exports = __webpack_public_path__ + "img/button_trash.daa80327.svg";